import { Injectable, Injector } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class ToasterService {
  constructor(
    public toastController: ToastController,
    private injector: Injector
  ) {}

  async errorToastWithClose(message: string) {
    const translate = this.injector.get(TranslateService);
    const toast = await this.toastController.create({
      message: translate.instant(message),
      position: 'bottom',
      color: 'danger',
      duration: 5000,
      cssClass: 'toast',
      mode: 'ios',
      buttons: [
        {
          text: translate.instant('Close'),
          role: 'cancel',
        },
      ],
    });
    await toast.present();
  }

  async successToastWithClose(message: string) {
    const translate = this.injector.get(TranslateService);

    const toast = await this.toastController.create({
      message: translate.instant(message),
      position: 'bottom',
      color: 'success',
      duration: 2000,
      cssClass: 'toast',
      mode: 'ios',
      buttons: [
        {
          text: translate.instant('Close'),
          role: 'cancel',
        },
      ],
    });
    await toast.present();
  }

  async successToast(message: string) {
    const translate = this.injector.get(TranslateService);

    const toast = await this.toastController.create({
      message: translate.instant(message),
      position: 'bottom',
      color: 'success',
      duration: 2000,
      mode: 'ios',
      cssClass: 'toast',
    });
    await toast.present();
  }

  async errorToast(message: string) {
    const translate = this.injector.get(TranslateService);

    const toast = await this.toastController.create({
      message: translate.instant(message),
      position: 'bottom',
      color: 'danger',
      duration: 2000,
      mode: 'ios',
      cssClass: 'toast',
    });
    await toast.present();
  }

  closeToaster() {
    this.toastController.dismiss();
  }

  async toast(message: string, button: string) {
    const translate = this.injector.get(TranslateService);

    const toast = await this.toastController.create({
      message: translate.instant(message),
      position: 'bottom',
      duration: 5000,
      cssClass: 'toast',
      mode: 'ios',
      buttons: [
        {
          side: 'end',
          text: translate.instant(button),
          role: 'button',
          handler: () => {
            console.log('Cancel clicked');
          },
        },
      ],
    });
    await toast.present();

    return await toast.onDidDismiss();
  }
}
